<style lang="less">
    .contrast .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.6rem .2rem .2rem;
        z-index: 9;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            background:#FFFDE4;
            padding:.2rem .4rem 0;
            position: unset;
            >div{
                width:100%;
                height:100%;
                overflow-y: auto;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
            }
        }
    }
    .contrast .play_trast_con{
        width:100%;
        height:auto;
        min-height: 4.8rem;
        padding:0.6rem 0.8rem 1.2rem;
        background:url("../assets/images/blackboard-phone.png") no-repeat;
        background-size:100% 100%;
        .text_drag{
            width:2.5rem;
            height:2.5rem;
            margin:0 auto;
            >div{
                width:2.5rem;
                height:2.5rem;
                background:#fff;
                z-index: 11112;
                font-size: 1.8rem;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .tips_text{
            // width:max-content;
            font-size: .32rem;
            color:#fff;
            text-align: center;
            margin:.4rem auto -.4rem;
            // transform: translateX(-50%);
            // position: absolute;
            // left:50%;
            // bottom:15%;
            // z-index: 11;
        }
        .res_right,.res_wrong{
            width:100%;
            height:3rem;
            font-size: .8rem;
            text-align: center;
            color:#fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
    .contrast .res_wrong{
        >div{
            width:2rem;
            height:auto;
            img{
                width:100%;
                height:auto;
                display: block;
                margin-top: .5rem;
                margin-bottom: -.5rem;
            }
        }
    }
    .contrast .tra_bottom{
        width:100%;
        margin:.6rem auto 0;
        padding-bottom: .9rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .drag_target{
            // width:1.1rem;
            .part{
                width:1.1rem;
                height:1.1rem;
                border:1px solid #000;
                padding:.06rem;
            }
            .leftright{
                display: flex;
                align-items: center;
                justify-content: space-between;
                >div{
                    width:calc(50% - .03rem);
                    height:100%;
                    background:#F47381;
                }
            }
            .updown{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                >div{
                    height:calc(50% - .03rem);
                    width:100%;
                    background:#F47381;
                }
            }
            .halfround{
                >div{
                    width:100%;
                    height:100%;
                    background:#F47381;
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-end;
                    >div{
                        width:calc(50% + .03rem);
                        height:calc(50% + .03rem);
                        border-left:.06rem solid #FFFDE4;
                        border-bottom:.06rem solid #FFFDE4;
                    }
                }
            }
            .allround{
                >div{
                    width:100%;
                    height:100%;
                    background:#F47381;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    >div{
                        width:calc(50% + .03rem);
                        height:calc(50% + .03rem);
                        background:#FFFDE4;
                    }
                }
            }
        }
    }
    .contrast .cantTouch{
        width:100vw;
        height:100vh;
        background:rgba(0, 0, 0, 0.3);
        position: fixed;
        left: 0;
        top:0;
        z-index: 11111;
    }
</style>
<template>
    <div class="contrast" @touchmove.prevent>
        <div class="pd">
            <div class="art_text_con"><!-- 蓝底 padding -->
                <img src="../assets/images/up-article-phone.png" alt="">
                <div class="art_inner"><!-- 黄底 padding -->
                    <div>
                        <div class="play_trast_con">
                            <div v-if="status == 'content'">
                                <div class="text_drag">
                                    <!-- <div ref="dragTarget" :style="'transform:translate('+moveX+'px,'+moveY+'px)'+' scale('+(drag_Start?.5:1)+')'" @touchstart="dragstart" @touchmove="dragmove" @touchend="dragend">{{gameData.question}}</div> -->
                                    <div ref="dragTarget">{{gameData.question}}</div>
                                </div>
                                <div class="tips_text">請選擇所屬結構</div>
                            </div>
                            <div v-else-if="status == 'right'" class="res_right">
                                <span>答對了！</span>
                            </div>
                            <div v-else-if="status == 'wrong'" class="res_wrong">
                                <span>答錯了</span>
                                <div @click.stop="init"><img src="../assets/images/play-again-pc.png" alt=""></div>
                            </div>
                        </div>
                    </div>
                    <div class="tra_bottom">
                        <div class="drag_target" @click="choiced(1)">
                            <div class="part leftright" ref="leftright">
                                <div></div>
                                <div></div>
                            </div>
                            <span>左右結構</span>
                        </div>
                        <div class="drag_target" @click="choiced(2)">
                            <div class="part updown" ref="updown">
                                <div></div>
                                <div></div>
                            </div>
                            <span>上下結構</span>
                        </div>
                        <div class="drag_target" @click="choiced(3)">
                            <div class="part halfround" ref="halfround">
                                <div>
                                    <div></div>
                                </div>
                            </div>
                            <span>半包圍結構</span>
                        </div>
                        <div class="drag_target" @click="choiced(4)">
                            <div class="part allround" ref="allround">
                                <div>
                                    <div></div>
                                </div>
                            </div>
                            <span>全包圍结构</span>
                        </div>
                    </div>
                </div>
                <img src="../assets/images/down-article-phone.png" alt="">
            </div>
        </div>

        <!-- 防误触遮罩 -->
        <div class="cantTouch" v-show="drag_Start" @touchstart.prevent  @touchmove.prevent  @touchend.prevent></div>
    </div>
</template>
<script>
export default {
    props:{
        gameData:{
            type:Object,
            default:{},
        },
        game_id:{
            type:String,
            default:'1',
        },
        date:{
            type:String,
            default:'',
        },
        push_id:{
            type:String,
            default:'',
        }
    },
    data(){
        return {
            options:['','leftright','updown','halfround','allround'],
            drag_Start:false,        //是否开始拖拽

            status:'content',       //内容区域显示控制

            moveevent:null,     //touchend事件没有相关坐标，从move里面拿
            clientX:'',
            clientY:'',
            moveX:0,
            moveY:0,
            orgx:'',
            orgy:'',
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        init(){
            console.log(111);
            this.drag_Start=false;        //是否开始拖拽
            this.status='content';       //内容区域显示控制
            this.moveevent=null;     //touchend事件没有相关坐标，从move里面拿
            this.clientX='';
            this.clientY='';
            this.moveX=0;
            this.moveY=0;
            this.orgx='';
            this.orgy='';
        },
        dragstart(e){
            console.log('开始拖拽',e.target.offsetLeft);
            console.log(e.touches[0].clientX);      
            // 缩放原点设置
            let width = parseInt(getComputedStyle(e.target).width);
            let height = parseInt(getComputedStyle(e.target).height);
            let parentTop = document.querySelector('.art_content').offsetTop;   //容器设置relative，要加上该容器的高度
            this.orgx = (e.touches[0].clientX - e.target.offsetLeft) * 100 / width;
            this.orgy = (e.touches[0].clientY - parentTop - e.target.offsetTop) * 100 / height;



            this.clientX = e.touches[0].clientX;
            this.clientY = e.touches[0].clientY;

            this.$refs.dragTarget.style.position = 'fixed';
            this.$refs.dragTarget.style.transformOrigin =  this.orgx +'% '+ this.orgy+'%';
            this.drag_Start = true;
        },
        dragmove(e){
            let clientX = e.touches[0].clientX;
            let clientY = e.touches[0].clientY;
            this.moveX = clientX - this.clientX;
            this.moveY = clientY - this.clientY;

            this.moveevent = e;

            // this.$refs.dragTarget.style.Transform = `translate(${this.moveX+','+this.moveY})`;
            // this.$refs.dragTarget.style.translateY = this.moveY;
            // console.log(this.moveX,this.moveY);
        },
        dragend(e){
            if(!this.moveevent){
                this.init();
                return;
            }
            console.log(e);
            let vm = this;
            let right = this.options[this.gameData.opts[0]];
            console.log(1111,right);
            // if(this.checkAnswer(right)){
            //     //检测正确
            //     this.status = 'right';
            // }else{
            //     //检测错误
            //     this.status = 'wrong';
            // }

            console.log(vm.baseUrl);
            let reuslt = this.checkAnswer();

            this.$http.get(vm.baseUrl+"/Game/structurePush/GaID/"+this.game_id+"/SrtSet/"+ reuslt +"/SrtTime/"+ 5 +'/pushdate/'+ this.date +"/sn/"+ Math.random()).then(res=>{
                console.log(res)
                if(res.data == 'pass'){
                    this.status = 'right';
                    setTimeout(()=>{
                        vm.$emit('next');
                    },3000)
                }else{
                    this.status = 'wrong';
                }
                
                //重置 状态控制渲染，不能在init里面重置样式
                vm.$refs.dragTarget.style.position = 'unset';
                vm.$refs.dragTarget.style.transformOrigin =  '50% 50%';
                vm.drag_Start = false;
            })
        },
        choiced(n){
            let vm = this;
            this.$http.get(vm.baseUrl+"/Game/structurePush/GaID/"+this.game_id+"/SrtSet/"+ n +"/SrtTime/"+ 5 +'/pushdate/'+ this.date +"/sn/"+ Math.random()).then(res=>{
                console.log(res)
                if(res.data == 'pass'){
                    this.status = 'right';
                    setTimeout(()=>{
                        vm.$emit('next');
                    },3000)
                }else{
                    this.status = 'wrong';
                }
                
                //重置 状态控制渲染，不能在init里面重置样式
                vm.$refs.dragTarget.style.position = 'unset';
                vm.$refs.dragTarget.style.transformOrigin =  '50% 50%';
                vm.drag_Start = false;
            })
        },
        checkAnswer(right){
            var e = this.moveevent;
            var box = document.querySelector('.part');
            var width = parseInt(getComputedStyle(box).width);
            var height = parseInt(getComputedStyle(box).height);

            var parentTop = document.querySelector('.art_content').offsetTop;   //容器设置relative，要加上该容器到顶部的高度

            var leftrightX = this.$refs.leftright.offsetLeft;
            var leftrightY = this.$refs.leftright.offsetTop + parentTop;
            var updownX = this.$refs.updown.offsetLeft;
            var updownY = this.$refs.updown.offsetTop + parentTop;
            var halfroundX = this.$refs.halfround.offsetLeft;
            var halfroundY = this.$refs.halfround.offsetTop + parentTop;
            var allroundX = this.$refs.allround.offsetLeft;
            var allroundY = this.$refs.allround.offsetTop + parentTop;


            console.log('leftright起点',leftrightX,leftrightX+width,'y---',leftrightY,leftrightY+height);
            console.log('updown起点',updownX,updownX+width,'y---',updownY,updownY+height);
            console.log('halfround起点',halfroundX,halfroundX+width,'y---',halfroundY,halfroundY+height);
            console.log('allround起点',allroundX,allroundX+width,'y---',allroundY,allroundY+height);
            
            var clientX = e.touches[0].clientX;
            var clientY = e.touches[0].clientY;
            console.log(clientX,clientY);
            if(clientX>=leftrightX && clientX <= (leftrightX+width) && clientY>=leftrightY && clientY <= (leftrightY+height)){//leftright  左右结构
                return 1;
            }else if(clientX>=updownX && clientX <= (updownX+width) && clientY>=updownY && clientY <= (updownY+height)){        //updown 上下结构
                return 2;
            }else if(clientX>=halfroundX && clientX <= (halfroundX+width) && clientY>=halfroundY && clientY <= (halfroundY+height)){    //halfround 半包围
                return 3;
            }else if(clientX>=allroundX && clientX <= (allroundX+width) && clientY>=allroundY && clientY <= (allroundY+height)){    //allround  全包围
                return 4;
            }else{
                return 0;
            }
            // switch(right){
            //     case 'leftright':
            //         if(clientX>=leftrightX && clientX <= (leftrightX+width) && clientY>=leftrightY && clientY <= (leftrightY+height)){
            //             result = true;
            //         }
            //         break;
            //     case 'updown':
            //         if(clientX>=updownX && clientX <= (updownX+width) && clientY>=updownY && clientY <= (updownY+height)){
            //             result = true;
            //         }
            //         break;
            //     case 'halfround':
            //         if(clientX>=halfroundX && clientX <= (halfroundX+width) && clientY>=halfroundY && clientY <= (halfroundY+height)){
            //             result = true;
            //         }
            //         break;
            //     case 'allround':
            //         if(clientX>=allroundX && clientX <= (allroundX+width) && clientY>=allroundY && clientY <= (allroundY+height)){
            //             result = true;
            //         }
            //         break;
            // }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/game-contrast.vue